import VueCookies from 'vue-cookies'

const TokenKey = 'merchant-Token'

export function getToken() {
  return VueCookies.get(TokenKey)
}

export function setToken(token) {
  return VueCookies.set(TokenKey, token);
}

export function removeToken() {
  return VueCookies.remove(TokenKey)
}

//获取IM凭证
export function getAuthToken() {
  return localStorage.getItem('authToken')
}